import React, { useEffect, useState } from 'react';

const AdminUserBadge = ({ className = '' }) => {
  const [adminName, setAdminName] = useState('Administrateur');

  useEffect(() => {
    const storedName = sessionStorage.getItem('NomAdmin');
    const storedRole = sessionStorage.getItem('Role');
    if (storedName && storedName.trim() !== '') {
      setAdminName(storedName);
    } else if (storedRole && storedRole.trim() !== '') {
      setAdminName(storedRole);
    } else {
      setAdminName('Administrateur');
    }
  }, []);

  return (
    <li className={`nav-item d-flex flex-column align-items-end ${className}`}>
      <span className="text-xs text-muted">Connecté en tant que</span>
      <strong className="text-sm text-dark text-uppercase">{adminName}</strong>
    </li>
  );
};

export default AdminUserBadge;


